module.exports = __webpack_public_path__ + "static/media/dmx-tab-sm.8e735198.svg";